import { useEffect, useState } from "react";

// Store leggero condiviso: useSEO pubblica i breadcrumb della pagina corrente,
// il componente <Breadcrumbs/> (montato nella Navbar) li mostra su tutte le
// pagine interne. La parte JSON-LD resta gestita da useSEO.
let current = [];
const listeners = new Set();

export function setBreadcrumbsStore(items) {
  current = Array.isArray(items) ? items : [];
  listeners.forEach((l) => l(current));
}

export function useBreadcrumbsStore() {
  const [items, setItems] = useState(current);
  useEffect(() => {
    listeners.add(setItems);
    setItems(current);
    return () => listeners.delete(setItems);
  }, []);
  return items;
}
